var map = {
	"./": 140,
	"./Clutch": 2691,
	"./Clutch.js": 2691,
	"./NewUi": 2692,
	"./NewUi.js": 2692,
	"./OldUi": 2693,
	"./OldUi.js": 2693,
	"./index": 140,
	"./index.js": 140,
	"./style": 859,
	"./style.js": 859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4219;